import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { TEL_HREF, whatsappHref } from "../mock";

// Persistent contact CTA, mobile only.
export default function MobileContactBar({ waText }) {
  return (
    <div className="fixed bottom-0 left-0 right-0 z-40 flex gap-2 border-t border-[var(--cm-line)] bg-[rgba(241,240,236,0.95)] p-3 backdrop-blur lg:hidden">
      <a
        href={TEL_HREF}
        className="flex flex-1 items-center justify-center gap-2 rounded-full border border-[var(--cm-line)] bg-white py-3 text-[0.9rem] font-medium"
      >
        <Phone size={16} /> Chiama
      </a>
      <a
        href={whatsappHref(waText)}
        target="_blank"
        rel="noopener noreferrer"
        className="flex flex-1 items-center justify-center gap-2 rounded-full bg-[var(--cm-ink)] py-3 text-[0.9rem] font-medium text-white"
      >
        <MessageCircle size={16} /> WhatsApp
      </a>
    </div>
  );
}
